import { getToken } from './auth';

const STORAGE_KEY = 'cc_token_v1';
const SKEW_SEC = 60; // refresh a minute early

let mem = null; // { access_token, expires_at }
let inflight = null; // Promise to de-duplicate concurrent fetches

function load() {
  if (mem) return mem;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw) mem = JSON.parse(raw);
  } catch {}
  return mem;
}

function save(obj) {
  mem = obj;
  try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(obj)); } catch {}
}

function expiringSoon() {
  const s = load();
  if (!s || !s.expires_at) return true;
  return Date.now() >= (s.expires_at - SKEW_SEC * 1000);
}

async function fetchFresh() {
  // single-flight to avoid stampede
  if (!inflight) {
    inflight = (async () => {
      const { access_token, expires_in } = await getToken();
      const session = {
        access_token,
        expires_at: Date.now() + (expires_in * 1000)
      };
      save(session);
      inflight = null;
      return session;
    })().catch(e => { inflight = null; throw e; });
  }
  return inflight;
}

export async function getPublicAccessToken() {
  if (expiringSoon()) {
    const s = await fetchFresh();
    return s.access_token;
  }
  return load().access_token;
}

export function clearPublicToken() {
  mem = null;
  try { sessionStorage.removeItem(STORAGE_KEY); } catch {}
}